"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consolePage = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The inset every console page sets on its own root, whatever product or
 * shell draws it: the frame around a page adds none, so a page looks the
 * same in every console. The page's header carries the space above it.
 */
const consolePage = exports.consolePage = {
  inset: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    flexGrow: "x1iyjqo2",
    minHeight: "x2lwn1j",
    boxSizing: "x9f619",
    paddingLeft: "x1vua2ax x1i3jmcq",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xnywu7s x1rvzbc9",
    $$css: true
  },
  roomBelow: {
    paddingBottom: "x163t5y5",
    $$css: true
  }
};